export default __webpack_public_path__ + "static/media/emerging-factor-image.1b2e40ec.svg";